import React from "react";
import {StyledCallUsContainer, StyledHeader} from "./Header.styles";
import {Col, Grid, Row} from "antd";
import {AdaptiveLogoIcon, AddressAdaptiveIcon, LogoIcon, PhoneIcon} from "../../assets";
import {Link, useLocation, useNavigate} from "react-router-dom";
import {ROUTE_PATH} from "../../constants";
const {useBreakpoint} = Grid;
export const Header = () => {
    const location = useLocation();
    const {pathname} = location;

    const navigate = useNavigate();

    const screens = useBreakpoint();

    return (
        <StyledHeader>
            <Col xs= {{
                pull: 1,
                span: 22,
                push: 1,
            }} lg={{
                pull: 3,
                span: 18,
                push: 3,
            }} xl={{
                pull: 4,
                span: 16,
                push: 4,
            }} style={{height: "100%"}}>
                <Row align="middle" justify="space-between" style={{height: "100%"}}>
                    <AdaptiveLogoIcon className="adaptiveLogo" onClick={() => navigate(ROUTE_PATH.MAIN)}/>
                    <LogoIcon className="normalLogo" onClick={() => navigate(ROUTE_PATH.MAIN)}/>

                    <Row align="middle" style={{position: "relative"}}>
                        {
                            !screens.sm ? <AddressAdaptiveIcon pathname={pathname}
                                                               onClick={() => navigate(pathname === "/area" ? "/" : "/area")}/> : pathname === "/area" ?
                              <span className="serviceArea"
                                    style={{color: pathname === "/area" ? "#003399" : "initial"}}
                                    onClick={() => navigate(pathname === "/area" ? "/" : "/area")}>Hide Service Area</span> :
                              <span className="serviceArea" onClick={() => navigate("/area")}>Service Area</span>
                        }
                        {/*{pathname === "/area" ?*/}
                        {/*    <AreaCurrentIcon className="areaCurrentIcon" onClick={() => navigate("/")} /> : null}*/}
                        <Link to="tel:(760) 439-7522">
                            <StyledCallUsContainer>
                                <PhoneIcon/>
                                <span className="phoneNumber">(760) 439-7522</span>
                            </StyledCallUsContainer>
                        </Link>
                    </Row>
                </Row>
            </Col>
        </StyledHeader>
    )
}